import { MatDialogRef } from '@angular/material/dialog';
import { ShipmentPlannerProfileModel } from '../models';

export class ShipmentPlannerDefaultProfileItemSetToggle {
  public static readonly type = '[ShipmentPlannerProfileItem] Set Default Profile Toggle';

  constructor(public payload: { profileId: number; isDefault: boolean }) {}
}

export class ShipmentPlannerDefaultProfileItemLoad {
  public static readonly type = '[ShipmentPlannerProfileItem] Load Default Profile';
}

export class ShipmentPlannerProfileItemLoad {
  public static readonly type = '[ShipmentPlannerProfileItem] Load';

  constructor(public payload: number) {}
}

export class ShipmentPlannerProfileItemCreate {
  public static readonly type = '[ShipmentPlannerProfileItem] Create';

  constructor(
    public payload: {
      dialog: MatDialogRef<unknown>;
      profile: Partial<ShipmentPlannerProfileModel>;
    },
  ) {}
}

export class ShipmentPlannerProfileItemUpdate {
  public static readonly type = '[ShipmentPlannerProfileItem] Update';

  constructor(public payload: Partial<ShipmentPlannerProfileModel>) {}
}

export class ShipmentPlannerProfileItemReset {
  public static readonly type = '[ShipmentPlannerProfileItem] Reset';
}

export class ShipmentPlannerProfileItemInitialState {
  public static readonly type = '[ShipmentPlannerProfileItem] Set Initial State';
}
